import { Radio } from '@helix-ds/react'
import type { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

/** One person's Accept / Decline answer for the current secondary item. */
export type SubjectChoiceRow = {
  key: string
  legend: string
  value: boolean | undefined
  existingSelection?: boolean
  onSelect: (value: boolean) => void
}

export function StandingSelectionNotice() {
  return (
    <p className="text-brand-700 col-span-full text-sm leading-6">
      <FormattedMessage
        id="consentOptions.secondaryChoice.existingSelection"
        defaultMessage="This is an existing selection and applies to all your orders."
      />
    </p>
  )
}

/** One fieldset per subject, in the order given; each row is its own radio group. */
export function SubjectChoiceRows({ rows }: { rows: SubjectChoiceRow[] }) {
  return (
    <>
      {rows.map((row) => (
        <fieldset key={row.key} className="grid gap-3 border-0 p-0 sm:grid-cols-2">
          <legend className="text-text-heading col-span-full mb-1 text-sm font-semibold">{row.legend}</legend>
          {row.existingSelection && <StandingSelectionNotice />}
          <SecondaryChoiceLabel
            name={`secondary-${row.key}`}
            label={<FormattedMessage id="consentOptions.secondaryChoice.accept" defaultMessage="Accept" />}
            checked={row.value === true}
            onSelect={() => row.onSelect(true)}
          />
          <SecondaryChoiceLabel
            name={`secondary-${row.key}`}
            label={<FormattedMessage id="consentOptions.secondaryChoice.decline" defaultMessage="Decline" />}
            checked={row.value === false}
            onSelect={() => row.onSelect(false)}
          />
        </fieldset>
      ))}
    </>
  )
}

export function SecondaryChoiceLabel({
  label,
  checked,
  onSelect,
  name,
}: {
  label: ReactNode
  checked: boolean
  onSelect: () => void
  name?: string
}) {
  return (
    <label
      className={`flex cursor-pointer items-center gap-3 rounded-full border px-4 py-3 text-sm font-semibold transition ${
        checked ? 'text-text-heading border-border-brand' : 'border-border-base text-text-body'
      }`}
    >
      <Radio name={name} checked={checked} onChange={onSelect} className="shrink-0" />
      {label}
    </label>
  )
}
